import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

import AuthLayout from '../layouts/AuthLayout.vue'
import AppLayout from '../layouts/AppLayout.vue'

import RouteViewComponent from '../layouts/RouterBypass.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/:pathMatch(.*)*',
    meta: { role: [] },
    redirect: { name: '404' },
  },
  {
    name: 'admin',
    path: '/',
    meta: { role: [] },
    component: AppLayout,
    redirect: { name: 'login' },
    children: [
      {
        name: 'main',
        path: 'main',
        meta: { role: [] },
        component: () => import('../pages/Main.vue'),
      },
      {
        name: 'subscription',
        path: 'subscription',
        meta: { role: ['ADMIN'] },
        component: () => import('../pages/subscriptions/SubscriptionPage.vue'),
      },
      {
        name: 'expert',
        path: 'expert',
        meta: { role: ['ADMIN', 'ASSISTANT'] },
        component: () => import('../pages/experts/ExpertPage.vue'),
      },
      {
        name: 'tariff',
        path: 'tariff',
        meta: { role: ['ADMIN', 'HEAD', 'MANAGER'] },
        component: () => import('../pages/tariff/TariffPage.vue'),
      },
      {
        name: 'dashboard',
        path: 'dashboard',
        meta: { role: [] },
        component: () => import('../pages/admin/dashboard/Dashboard.vue'),
      },
      {
        name: 'settings',
        path: 'settings',
        meta: { role: [] },
        component: () => import('../pages/settings/Settings.vue'),
      },
      {
        name: 'preferences',
        path: 'preferences',
        meta: { role: [] },
        component: () => import('../pages/preferences/Preferences.vue'),
      },
      {
        name: 'users',
        path: 'users',
        meta: { role: [] },
        component: () => import('../pages/users/UsersPage.vue'),
      },
      {
        name: 'projects',
        path: 'projects',
        meta: { role: [] },
        component: () => import('../pages/projects/ProjectsPage.vue'),
      },
      {
        name: 'payments',
        path: '/payments',
        meta: { role: [] },
        component: RouteViewComponent,
        children: [
          {
            name: 'payment-methods',
            path: 'payment-methods',
            meta: { role: [] },
            component: () => import('../pages/payments/PaymentsPage.vue'),
          },
          {
            name: 'billing',
            path: 'billing',
            meta: { role: [] },
            component: () => import('../pages/billing/BillingPage.vue'),
          },
          {
            name: 'pricing-plans',
            path: 'pricing-plans',
            meta: { role: [] },
            component: () => import('../pages/pricing-plans/PricingPlans.vue'),
          },
        ],
      },
      {
        name: 'faq',
        path: '/faq',
        meta: { role: [] },
        component: () => import('../pages/faq/FaqPage.vue'),
      },
      {
        name: 'test',
        path: '/test',
        meta: { role: [] },
        component: () => import('../pages/test/TestPage.vue'),
      },
    ],
  },
  {
    path: '/auth',
    meta: { role: [] },
    component: AuthLayout,
    children: [
      {
        name: 'login',
        path: 'login',
        meta: { role: [] },
        component: () => import('../pages/auth/Login.vue'),
      },
      {
        name: 'signup',
        path: 'signup',
        meta: { role: [] },
        component: () => import('../pages/auth/Signup.vue'),
      },
      {
        name: 'recover-password',
        path: 'recover-password',
        meta: { role: [] },
        component: () => import('../pages/auth/RecoverPassword.vue'),
      },
      {
        name: 'recover-password-email',
        path: 'recover-password-email',
        meta: { role: [] },
        component: () => import('../pages/auth/CheckTheEmail.vue'),
      },
      {
        path: '',
        meta: { role: [] },
        redirect: { name: 'login' },
      },
    ],
  },
  {
    name: '404',
    path: '/404',
    meta: { role: [] },
    component: () => import('../pages/404.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    // For some reason using documentation example doesn't scroll on page navigation.
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' }
    } else {
      window.scrollTo(0, 0)
    }
  },
  routes,
})

router.beforeEach(async (to, from, next) => {
  console.log('Navigating to:', to.name)
  console.log('Matched components:', to.matched)
  next()

  // if (to.meta.role) {
  //   const store = useAuthStore()
  //   if (!store.user) {
  //     return '/login'
  //   } else {
  //     console.log('beforeEach')
  //     console.log(to)
  //     console.log(from)
  //   }
  // }
})

export default router
